"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BrandsPayoutListCtl = /** @class */ (function (_super) {
    __extends(BrandsPayoutListCtl, _super);
    function BrandsPayoutListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_app_payout_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_payout_id; });
        _this.dk_app_payout_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_payout_title; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_comission_fixed_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.comission_fixed_amount; });
        _this.dk_comission_percent_x100 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.comission_percent_x100; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_min_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_amount; });
        _this.dk_max_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_amount; });
        _this.dk_gateway = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gateway; });
        _this.dk_json_tpl = UIUtils_1.UIUtils.IProp2Str(function (o) { o.json_tpl; });
        _this.dk_json_tpl_test_data = UIUtils_1.UIUtils.IProp2Str(function (o) { o.json_tpl_test_data; });
        _this.dk_account_regex_js = UIUtils_1.UIUtils.IProp2Str(function (o) { o.account_regex_js; });
        _this.dk_is_use_account_regex_js = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_use_account_regex_js; });
        _this.dk_account_example = UIUtils_1.UIUtils.IProp2Str(function (o) { o.account_example; });
        _this.dk_is_dynamic_gateway = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_dynamic_gateway; });
        _this.dk_gateway_tpl = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gateway_tpl; });
        _this.dk_payout_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.payout_type_code; });
        _this.dk_payout_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.payout_type_title; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandsPayoutListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    BrandsPayoutListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    BrandsPayoutListCtl.prototype.LoadData = function (brandId, onDone) {
        var _this = this;
        webAApi_1.ListBrandAppPayoutsByBrandIdGet.exec({ brand_id: brandId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_payout_id: resp.list[i].app_payout_id,
                    app_payout_title: resp.list[i].app_payout_title,
                    app_currency_title: resp.list[i].app_currency_title,
                    comission_percent_x100: resp.list[i].comission_percent_x100,
                    comission_fixed_amount: resp.list[i].comission_fixed_amount,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    is_locked: resp.list[i].is_locked,
                    min_amount: resp.list[i].min_amount,
                    max_amount: resp.list[i].max_amount,
                    gateway: resp.list[i].gateway,
                    json_tpl: resp.list[i].json_tpl,
                    json_tpl_test_data: resp.list[i].json_tpl_test_data,
                    is_use_account_regex_js: resp.list[i].is_use_account_regex_js,
                    account_regex_js: resp.list[i].account_regex_js,
                    account_example: resp.list[i].account_example,
                    is_dynamic_gateway: resp.list[i].is_dynamic_gateway,
                    gateway_tpl: resp.list[i].gateway_tpl,
                    payout_type_code: resp.list[i].payout_type_code,
                    payout_type_title: resp.list[i].payout_type_title,
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsPayoutListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandAppPayout.exec({
            data: {
                app_payout_id: data.app_payout_id,
                brand_id: data.brand_id,
                is_locked: data.is_locked,
                comission_percent_x100: data.comission_percent_x100,
                comission_fixed_amount: data.comission_fixed_amount,
                min_amount: data.min_amount,
                max_amount: data.max_amount,
                gateway: data.gateway,
                json_tpl: data.json_tpl,
                account_regex_js: data.account_regex_js,
                is_use_account_regex_js: data.is_use_account_regex_js,
                account_example: data.account_example,
                is_dynamic_gateway: data.is_dynamic_gateway,
                gateway_tpl: data.gateway_tpl,
                payout_type_code: data.payout_type_code,
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_payout_id: data.app_payout_id,
                app_payout_title: resp.app_payout_title,
                app_currency_title: resp.app_currency_title,
                comission_percent_x100: data.comission_percent_x100,
                comission_fixed_amount: data.comission_fixed_amount,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                is_locked: data.is_locked,
                min_amount: data.min_amount,
                max_amount: data.max_amount,
                gateway: data.gateway,
                json_tpl: data.json_tpl,
                json_tpl_test_data: resp.for_test_data,
                account_regex_js: data.account_regex_js,
                is_use_account_regex_js: data.is_use_account_regex_js,
                account_example: data.account_example,
                is_dynamic_gateway: data.is_dynamic_gateway,
                gateway_tpl: data.gateway_tpl,
                payout_type_code: data.payout_type_code,
                payout_type_title: resp.payout_type_title,
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsPayoutListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandAppPayout.exec({
                data: {
                    brand_app_payout_id: data.key,
                    app_payout_id: data.app_payout_id,
                    is_locked: data.is_locked,
                    comission_fixed_amount: data.comission_fixed_amount,
                    comission_percent_x100: data.comission_percent_x100,
                    min_amount: data.min_amount,
                    max_amount: data.max_amount,
                    gateway: data.gateway,
                    json_tpl: data.json_tpl,
                    account_regex_js: data.account_regex_js,
                    is_use_account_regex_js: data.is_use_account_regex_js,
                    account_example: data.account_example,
                    is_dynamic_gateway: data.is_dynamic_gateway,
                    gateway_tpl: data.gateway_tpl,
                    payout_type_code: data.payout_type_code
                }
            }, function (resp) {
                _tmp.app_payout_id = data.app_payout_id;
                _tmp.app_payout_title = resp.app_payout_title;
                _tmp.app_currency_title = resp.app_currency_title;
                _tmp.is_locked = data.is_locked;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.comission_fixed_amount = data.comission_fixed_amount;
                _tmp.comission_percent_x100 = data.comission_percent_x100;
                _tmp.min_amount = data.min_amount;
                _tmp.max_amount = data.max_amount;
                _tmp.account_regex_js = data.account_regex_js;
                _tmp.is_use_account_regex_js = data.is_use_account_regex_js;
                _tmp.gateway = data.gateway;
                _tmp.json_tpl = data.json_tpl;
                _tmp.is_dynamic_gateway = data.is_dynamic_gateway;
                _tmp.gateway_tpl = data.gateway_tpl;
                _tmp.payout_type_code = data.payout_type_code;
                _tmp.payout_type_title = resp.payout_type_title;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsPayoutListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BrandsPayoutListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandAppPayout.exec({
                data: {
                    brand_app_payout_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsPayoutListCtl.prototype.DoSetIsLocked = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandAppPayoutIsLocked.exec({ data: { brand_app_payout_id: key, is_locked: isLocked } }, function (resp) {
                _tmp.is_locked = isLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsPayoutListCtl.prototype.DetailsAppPayoutGet = function (onDone) {
        var _this = this;
        webAApi_1.DetailBrandAppPayoutTemplateDataGet.exec({}, function (resp) {
            _this.Update();
            if (onDone) {
                onDone(resp.for_test_data);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsPayoutListCtl.prototype.DoRenderTPLByTestData = function (jsonTpl, jsonTest, onDone) {
        var _this = this;
        webAApi_1.DoRenderBrandAppTemplateByTestData.exec({ data: { tpl_text: jsonTpl, json_data: jsonTest } }, function (resp) {
            _this.Update();
            if (onDone) {
                onDone(resp.rendered_txt);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return BrandsPayoutListCtl;
}(BaseController_1.BaseController));
exports.BrandsPayoutListCtl = BrandsPayoutListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/options/BrandsPayoutsListCtl.ts
// module id = 988
// module chunks = 0